import { message } from "antd";
import { forEach, get, map } from "lodash";
import usePostUrlCanAbort from "../../../../custom-hooks/usePostUrlCanAbort";
import { doResearchOnlineRegex, makeACallRegex } from "./constants";
import func from "@uikit/func";

const streamUrl = "/stream/bas-demo-v4/nlp/completions_generation";
const url = "/be/bas-demo-v4/nlp/completions_generation";

const useNodeTypeData = () => {
  const { postData, postWithStreaming } = usePostUrlCanAbort();

  const fetchMakeACallData = async (lineText, nodeText, callback, callbackPromiseHandle) => {
    return await postWithStreaming(
      streamUrl,
      {
        domain: "brain_studios",
        identifier_type: "file",
        identifier_value: "agent_node_description_generation_from_previous_node_and_edge.model",
        stream: true,
        variables: {
          instruction: lineText,
          context: nodeText,
        },
      },
      msg => callback(msg.choices?.[0]?.text || msg.choices?.[0]?.delta?.content || ""),
      false,
      callbackPromiseHandle
    );
  };

  const fetchDoResearchData = async (lineText, nodeText, callback, callbackPromiseHandle) => {
    return await postWithStreaming(
      streamUrl,
      {
        domain: "brain_studios",
        identifier_type: "file",
        identifier_value: "research_agent_goal_generation.model",
        stream: true,
        variables: {
          instruction: lineText,
          context: nodeText,
        },
      },
      msg => callback(msg.choices?.[0]?.text || msg.choices?.[0]?.delta?.content || ""),
      false,
      callbackPromiseHandle
    );
  };

  const getNodeTypeData = async (lineText, nodeText, onResponseStreamText = () => {}) => {
    const nodeTypeMappings = [
      {
        key: "make a call",
        promise: fetchMakeACallData,
        isCurrentType: false,
        promiseHandle: null,
        text: "",
      },
      {
        key: "do research online",
        promise: fetchDoResearchData,
        isCurrentType: false,
        promiseHandle: null,
        text: "",
      },
    ];

    const sendMessage = (index, text) => {
      const currentMapping = nodeTypeMappings[index];
      nodeTypeMappings[index].text = nodeTypeMappings[index].text + text;
      if (currentMapping.isCurrentType === true) {
        onResponseStreamText(nodeTypeMappings[index].text, currentMapping.key);
      }
    };

    // Make a call
    if (makeACallRegex.test(lineText)) {
      nodeTypeMappings[0].isCurrentType = true;
      await fetchMakeACallData(lineText, nodeText, text => sendMessage(0, text));
      return true;
    }

    // Do research online
    if (doResearchOnlineRegex.test(lineText)) {
      nodeTypeMappings[1].isCurrentType = true;
      await fetchDoResearchData(lineText, nodeText, text => sendMessage(1, text));
      return true;
    }

    try {
      postData(
        url,
        {
          domain: "brain_studios",
          identifier_type: "file",
          identifier_value: "edge_domain_mapping.model",
          stream: false,
          variables: {
            input: lineText,
          },
        },
        false
      ).then(res => {
        if (res.status === 200) {
          const key = get(res, "data.choices.0.text", "").trim().toLowerCase();
          forEach(nodeTypeMappings, mapping => {
            if (mapping.key === key) {
              mapping.isCurrentType = true;
            } else {
              mapping.promiseHandle?.cancel?.();
            }
          });
        } else {
          func.customMsg({
            content: "Failed to fetch prompt",
          });
        }
      });
    } catch (error) {
      func.messageError(error);
    }

    try {
      await Promise.all(
        map(nodeTypeMappings, (item, index, array) => {
          return item.promise(
            lineText,
            nodeText,
            text => {
              sendMessage(index, text);
            },
            promiseHandle => {
              array[index].promiseHandle = promiseHandle;
            }
          );
        })
      );
    } catch (error) {
      console.error(error);
    }
    return nodeTypeMappings.some(mapping => mapping.isCurrentType);
  };

  return { getNodeTypeData };
};

export default useNodeTypeData;
